import { SvgIcon } from '@material-ui/core'

export default function HistogramIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.41379 19.2412H2.34483C2.15414 19.2412 2 19.3957 2 19.586V21.655C2 21.8453 2.15414 21.9998 2.34483 21.9998H4.41379C4.60448 21.9998 4.75862 21.8453 4.75862 21.655V19.586C4.75862 19.3957 4.60448 19.2412 4.41379 19.2412Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.41379 15.793H2.34483C2.15414 15.793 2 15.9475 2 16.1378V18.2068C2 18.3971 2.15414 18.5516 2.34483 18.5516H4.41379C4.60448 18.5516 4.75862 18.3971 4.75862 18.2068V16.1378C4.75862 15.9475 4.60448 15.793 4.41379 15.793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.85911 15.793H5.79014C5.59945 15.793 5.44531 15.9475 5.44531 16.1378V18.2068C5.44531 18.3971 5.59945 18.5516 5.79014 18.5516H7.85911C8.04979 18.5516 8.20393 18.3971 8.20393 18.2068V16.1378C8.20393 15.9475 8.04979 15.793 7.85911 15.793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.41379 12.3447H2.34483C2.15414 12.3447 2 12.4992 2 12.6896V14.7585C2 14.9489 2.15414 15.1033 2.34483 15.1033H4.41379C4.60448 15.1033 4.75862 14.9489 4.75862 14.7585V12.6896C4.75862 12.4992 4.60448 12.3447 4.41379 12.3447Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.41379 8.89648H2.34483C2.15414 8.89648 2 9.05097 2 9.24131V11.3103C2 11.5006 2.15414 11.6551 2.34483 11.6551H4.41379C4.60448 11.6551 4.75862 11.5006 4.75862 11.3103V9.24131C4.75862 9.05097 4.60448 8.89648 4.41379 8.89648Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.85911 12.3447H5.79014C5.59945 12.3447 5.44531 12.4992 5.44531 12.6896V14.7585C5.44531 14.9489 5.59945 15.1033 5.79014 15.1033H7.85911C8.04979 15.1033 8.20393 14.9489 8.20393 14.7585V12.6896C8.20393 12.4992 8.04979 12.3447 7.85911 12.3447Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.85911 8.89648H5.79014C5.59945 8.89648 5.44531 9.05097 5.44531 9.24131V11.3103C5.44531 11.5006 5.59945 11.6551 5.79014 11.6551H7.85911C8.04979 11.6551 8.20393 11.5006 8.20393 11.3103V9.24131C8.20393 9.05097 8.04979 8.89648 7.85911 8.89648Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.41379 5.44824H2.34483C2.15414 5.44824 2 5.60272 2 5.79307V7.86204C2 8.05238 2.15414 8.20686 2.34483 8.20686H4.41379C4.60448 8.20686 4.75862 8.05238 4.75862 7.86204V5.79307C4.75862 5.60272 4.60448 5.44824 4.41379 5.44824Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7575 12.3447H12.6886C12.4979 12.3447 12.3438 12.4992 12.3438 12.6896V14.7585C12.3438 14.9489 12.4979 15.1033 12.6886 15.1033H14.7575C14.9482 15.1033 15.1024 14.9489 15.1024 14.7585V12.6896C15.1024 12.4992 14.9482 12.3447 14.7575 12.3447Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7575 8.89648H12.6886C12.4979 8.89648 12.3438 9.05097 12.3438 9.24131V11.3103C12.3438 11.5006 12.4979 11.6551 12.6886 11.6551H14.7575C14.9482 11.6551 15.1024 11.5006 15.1024 11.3103V9.24131C15.1024 9.05097 14.9482 8.89648 14.7575 8.89648Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7575 5.44824H12.6886C12.4979 5.44824 12.3438 5.60272 12.3438 5.79307V7.86204C12.3438 8.05238 12.4979 8.20686 12.6886 8.20686H14.7575C14.9482 8.20686 15.1024 8.05238 15.1024 7.86204V5.79307C15.1024 5.60272 14.9482 5.44824 14.7575 5.44824Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6521 12.3447H19.5831C19.3924 12.3447 19.2383 12.4992 19.2383 12.6896V14.7585C19.2383 14.9489 19.3924 15.1033 19.5831 15.1033H21.6521C21.8428 15.1033 21.9969 14.9489 21.9969 14.7585V12.6896C21.9969 12.4992 21.8428 12.3447 21.6521 12.3447Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6521 8.89648H19.5831C19.3924 8.89648 19.2383 9.05097 19.2383 9.24131V11.3103C19.2383 11.5006 19.3924 11.6551 19.5831 11.6551H21.6521C21.8428 11.6551 21.9969 11.5006 21.9969 11.3103V9.24131C21.9969 9.05097 21.8428 8.89648 21.6521 8.89648Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6521 5.44824H19.5831C19.3924 5.44824 19.2383 5.60272 19.2383 5.79307V7.86204C19.2383 8.05238 19.3924 8.20686 19.5831 8.20686H21.6521C21.8428 8.20686 21.9969 8.05238 21.9969 7.86204V5.79307C21.9969 5.60272 21.8428 5.44824 21.6521 5.44824Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6521 2H19.5831C19.3924 2 19.2383 2.15448 19.2383 2.34483V4.41379C19.2383 4.60414 19.3924 4.75862 19.5831 4.75862H21.6521C21.8428 4.75862 21.9969 4.60414 21.9969 4.41379V2.34483C21.9969 2.15448 21.8428 2 21.6521 2Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7575 15.793H12.6886C12.4979 15.793 12.3438 15.9475 12.3438 16.1378V18.2068C12.3438 18.3971 12.4979 18.5516 12.6886 18.5516H14.7575C14.9482 18.5516 15.1024 18.3971 15.1024 18.2068V16.1378C15.1024 15.9475 14.9482 15.793 14.7575 15.793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2068 15.793H16.1378C15.9471 15.793 15.793 15.9475 15.793 16.1378V18.2068C15.793 18.3971 15.9471 18.5516 16.1378 18.5516H18.2068C18.3975 18.5516 18.5516 18.3971 18.5516 18.2068V16.1378C18.5516 15.9475 18.3975 15.793 18.2068 15.793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2068 12.3447H16.1378C15.9471 12.3447 15.793 12.4992 15.793 12.6896V14.7585C15.793 14.9489 15.9471 15.1033 16.1378 15.1033H18.2068C18.3975 15.1033 18.5516 14.9489 18.5516 14.7585V12.6896C18.5516 12.4992 18.3975 12.3447 18.2068 12.3447Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6521 15.793H19.5831C19.3924 15.793 19.2383 15.9475 19.2383 16.1378V18.2068C19.2383 18.3971 19.3924 18.5516 19.5831 18.5516H21.6521C21.8428 18.5516 21.9969 18.3971 21.9969 18.2068V16.1378C21.9969 15.9475 21.8428 15.793 21.6521 15.793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.85911 19.2412H5.79014C5.59945 19.2412 5.44531 19.3957 5.44531 19.586V21.655C5.44531 21.8453 5.59945 21.9998 5.79014 21.9998H7.85911C8.04979 21.9998 8.20393 21.8453 8.20393 21.655V19.586C8.20393 19.3957 8.04979 19.2412 7.85911 19.2412Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3122 19.2412H9.24327C9.05258 19.2412 8.89844 19.3957 8.89844 19.586V21.655C8.89844 21.8453 9.05258 21.9998 9.24327 21.9998H11.3122C11.5029 21.9998 11.6571 21.8453 11.6571 21.655V19.586C11.6571 19.3957 11.5029 19.2412 11.3122 19.2412Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3122 15.793H9.24327C9.05258 15.793 8.89844 15.9475 8.89844 16.1378V18.2068C8.89844 18.3971 9.05258 18.5516 9.24327 18.5516H11.3122C11.5029 18.5516 11.6571 18.3971 11.6571 18.2068V16.1378C11.6571 15.9475 11.5029 15.793 11.3122 15.793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7575 19.2412H12.6886C12.4979 19.2412 12.3438 19.3957 12.3438 19.586V21.655C12.3438 21.8453 12.4979 21.9998 12.6886 21.9998H14.7575C14.9482 21.9998 15.1024 21.8453 15.1024 21.655V19.586C15.1024 19.3957 14.9482 19.2412 14.7575 19.2412Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2068 19.2412H16.1378C15.9471 19.2412 15.793 19.3957 15.793 19.586V21.655C15.793 21.8453 15.9471 21.9998 16.1378 21.9998H18.2068C18.3975 21.9998 18.5516 21.8453 18.5516 21.655V19.586C18.5516 19.3957 18.3975 19.2412 18.2068 19.2412Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6521 19.2412H19.5831C19.3924 19.2412 19.2383 19.3957 19.2383 19.586V21.655C19.2383 21.8453 19.3924 21.9998 19.5831 21.9998H21.6521C21.8428 21.9998 21.9969 21.8453 21.9969 21.655V19.586C21.9969 19.3957 21.8428 19.2412 21.6521 19.2412Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
